import React from 'react';
import {
  DateField,
  EmailField,
  SelectField,
  Show,
  SimpleShowLayout,
  TextField,
  useShowController,
} from 'react-admin';
import { choices, LicenseeStatus, planNameChoices } from './constants';
import ContractActions from './actions/contractActions';

const ContractShow = (props) => {
  const { record } = useShowController(props);
  if (!record) return null;

  const isLegal = record?.licenseeStatus === LicenseeStatus.LEGAL;
  const isIndividualEntrepreneur =
    record?.licenseeStatus === LicenseeStatus.INDIVIDUAL_ENTREPRENEUR;

  return (
    <Show
      actions={
        <ContractActions
          data={record}
          basePath={props.basePath}
          resource={props.resource}
        />
      }
      {...props}
    >
      <SimpleShowLayout>
        <SelectField
          source="planName"
          label="Тариф"
          choices={planNameChoices}
        />
        <DateField source="dateFrom" label="Действует с" />
        <DateField source="dateTo" label="Действует по" />
        <TextField source="amount" label="Общая стоимость" />
        <DateField source="dateEnd" label="Действует до" />
        <EmailField label="Email пользователя платформы" source="userEmail" />
        <TextField
          source="bankDetails.account"
          label="Номер расчетного счета"
        />
        <TextField
          source="bankDetails.correspondentAccount"
          label="Номер корреспондентского счета"
        />
        <TextField source="bankDetails.bic" label="БИК" />
        <TextField
          source="bankDetails.name"
          label="Полное наименование банка"
        />
        <SelectField
          source="licenseeStatus"
          label="Статус лицензиата"
          choices={choices}
        />
        {isLegal && <TextField source="legal.name" label="Наименование" />}
        {isLegal && (
          <TextField source="legal.legalAddress" label="Юридический адрес" />
        )}
        {isLegal && (
          <TextField source="legal.postalAddress" label="Почтовый адрес" />
        )}
        {isLegal && <TextField source="legal.inn" label="ИНН" />}
        {isLegal && <TextField source="legal.kpp" label="КПП" />}
        {isLegal && <TextField source="legal.ogrn" label="ОГРН" />}
        {isLegal && <TextField source="legal.phone" label="Телефон" />}
        {isLegal && <TextField source="legal.email" label="Email" />}
        {isLegal && (
          <TextField source="legal.fio" label="ФИО Генерального директора" />
        )}
        {isIndividualEntrepreneur && (
          <TextField source="individualEntrepreneur.fio" label="ФИО" />
        )}
        {isIndividualEntrepreneur && (
          <TextField
            source="individualEntrepreneur.registrationAddress"
            label="Адрес регистрации"
          />
        )}
        {isIndividualEntrepreneur && (
          <TextField source="individualEntrepreneur.inn" label="ИНН" />
        )}
        {isIndividualEntrepreneur && (
          <TextField source="individualEntrepreneur.ogrnip" label="ОГРНИП" />
        )}
        {isIndividualEntrepreneur && (
          <TextField source="individualEntrepreneur.phone" label="Телефон" />
        )}
        {isIndividualEntrepreneur && (
          <TextField source="individualEntrepreneur.email" label="Email" />
        )}
      </SimpleShowLayout>
    </Show>
  );
};

export default ContractShow;
